const keys = polling => Object.keys(polling)

const pollingError = polling => keys(polling).reduce((accumulator, key) => accumulator || polling[key].error, false)

const donePolling = polling =>
  keys(polling).reduce((accumulator, key) => accumulator || polling[key].isPolling === false, false)

export const activePollingId = ({ polling }) =>
  keys(polling).reduce((id, key) => {
    if (id) return id
    return polling[key].error ? key : undefined
  }, undefined)

export const isActivelyPolling = ({ polling }) =>
  keys(polling).length > 0 && !pollingError(polling) && !donePolling(polling)
